import PropTypes from "prop-types";
import { SuiModal } from "../../common/suiModal";
import { walmartMXTranslations as t } from "../../../translations/walmartMXTranslations";

const BrandLiftDeactivateModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <SuiModal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={t.brandLiftDeactivateModalTitle}
      modalContent={<p>{t.brandLiftDeactivateMessage}</p>}
      modalButtons={[
        {
          text: t.brandLiftDeactivateCancelBtn,
          onClick: onClose,
        },
        {
          text: t.brandLiftDeactivateConfirmBtn,
          color: "primary",
          onClick: onConfirm,
        },
      ]}
    />
  );
};

BrandLiftDeactivateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default BrandLiftDeactivateModal;
